const reviews = [
  { name: "读者·阿梨", role: "吃瓜重度用户", text: "以前刷半天碎片信息也拼不完整件事，现在爆炸瓜一条时间线就把前因后果讲透了，太省心。" },
  { name: "读者·老K", role: "媒体从业者", text: "能把「反转再反转」梳理得这么清晰的中文站不多，节点都带时间戳，做素材引用很放心。" },
  { name: "读者·小满", role: "品牌公关从业者", text: "反观案例库尤其好用，看别人翻车是怎么一步步发酵、道歉、修复的，对我们的工作很有参考价值。" },
];

const principles = [
  { icon: "ri-honour-line", title: "以事实为尺", text: "每个节点基于多方公开信源交叉核实，未实锤内容明确标注，绝不带节奏。" },
  { icon: "ri-timer-line", title: "让时间说话", text: "我们相信完整的时间线胜过碎片化的判断，把判断权交还给屏幕前的你。" },
  { icon: "ri-heart-line", title: "克制而温和", text: "热点有温度，我们拒绝猎奇与渲染，始终把当事人的基本尊重放在流量之前。" },
];

export default function Editorial() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.2fr] lg:items-center">
          <div>
            <p className="inline-flex items-center gap-2 text-sm font-bold text-accent-700">
              <span className="h-px w-6 bg-accent-500" />
              编辑部的立场
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-4xl">
              我们不追逐流量，
              <br />
              只对事实负责
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              爆炸瓜相信，一个负责任的吃瓜现场不该是谣言的温床。
              所以当某个事件持续更新、反转再反转时，我们选择退后一步，把时间线、来源与节点原原本本摆出来，
              剩下的判断，交给每一个独立思考的你。
            </p>
            <div className="mt-7 flex flex-col gap-5">
              {principles.map((p) => (
                <div key={p.title} className="flex items-start gap-3">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                    <i className={`${p.icon} text-lg`} />
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950">{p.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{p.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4">
            {reviews.map((r) => (
              <figure key={r.name} className="rounded-2xl border border-background-200 bg-background-100 p-6">
                <div className="flex gap-0.5 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                  “{r.text}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-200 text-sm font-bold text-secondary-800">
                    {r.name.slice(-2)}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-900">{r.name}</p>
                    <p className="text-xs text-foreground-500">{r.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}